import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { useDeviceDetectorContext } from '../../../../../../device-detector'
import { useCopyText } from '../../../../../../generic-hooks'
import { useProductPageContext } from '../../../../productPageContext'

const ProductBuyBoxSocialPopupModalCopyLink: FC = () => {
  const { product } = useProductPageContext()
  const { deviceType } = useDeviceDetectorContext()

  const urlToBeCopied = `${product.canonical_url}?campaign=share/copylink/${deviceType}/${product.upid}`

  const { copied, copyText } = useCopyText(urlToBeCopied)

  return (
    <>
      <div className="my-5 truncate rounded-full border border-dark-primary-min bg-light-primary-low px-6 py-4 text-dark-primary-strong">
        {copied ? (
          <div className="text-dark-success">
            <FormattedMessage id="socialModal.label.linkCopied" />
          </div>
        ) : (
          urlToBeCopied
        )}
      </div>
      <button
        className="font-medium text-dark-brand hover:underline"
        onClick={(): void => {
          void copyText()
        }}
        type="button"
      >
        <FormattedMessage id="socialModal.button.copyLink" />
      </button>
    </>
  )
}

export { ProductBuyBoxSocialPopupModalCopyLink }
